import { getDataFromJSON } from './getDataFromJSON';

export default function getLocalStorageData(key) {
    return localStorage.getItem(key) && getDataFromJSON(localStorage.getItem(key));
}
